import Calendar from "@mui/icons-material/Event";
import DatePicker, { registerLocale } from "react-datepicker";
import { enGB, ar } from "date-fns/locale";
import "react-datepicker/dist/react-datepicker.css";
import "./index.css";

registerLocale("ar", ar);
registerLocale("en", enGB);

interface IDateTimePickerProps {
  startDate: Date | null;
  endDate: Date | null;
  setDateRange(date: [Date | null, Date | null]): void;
  locale: string;
}

function DateRangePicker({
  startDate,
  endDate,
  setDateRange,
  locale,
}: Readonly<IDateTimePickerProps>) {
  return (
    <DatePicker
      showIcon
      icon={<Calendar sx={{ fontSize: "35px", color: "rgb(33, 107, 165)" }} />}
      toggleCalendarOnIconClick
      startDate={startDate}
      endDate={endDate}
      dateFormat="dd MMMM yyyy"
      className="datePicker"
      popperClassName="popper"
      calendarClassName="calender"
      dayClassName={() => "day"}
      weekDayClassName={() => "week"}
      timeClassName={() => "time"}
      onChange={(update) => {
        setDateRange(update);
      }}
      locale={locale}
      selectsRange
      showWeekNumbers
      shouldCloseOnSelect
      calendarStartDay={1}
      onKeyDown={(e) => e.preventDefault()}
    />
  );
}

export default DateRangePicker;
